import React from 'react'

const TextHighlighted = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className="text-formatted" dangerouslySetInnerHTML={{__html: block.text}}></div>
    </div>
  </section>
)

export default TextHighlighted
